import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const ContactRequest = lazyWithSuspense(async () => import('./ContactRequestScreen'), {
  loadingState: <LoadingState />,
});
